import FormEntry from "../../../../src/components/docs/examples/Forms/FormEntry";
import FormEntrySelect from "../../../../src/components/docs/examples/Forms/FormEntrySelect";
import FormEntryTextarea from "../../../../src/components/docs/examples/Forms/FormEntryTextarea";
import FormEntryFileUpload from "../../../../src/components/docs/examples/Forms/FormEntryFileUpload";
import Checkboxes from "../../../../src/components/docs/examples/Forms/Checkboxes";
import CheckboxSingle from "../../../../src/components/docs/examples/Forms/CheckboxSingle";
import CheckboxSwitch from "../../../../src/components/docs/examples/Forms/CheckboxSwitch";
import Radios from "../../../../src/components/docs/examples/Forms/Radios";
import RequiredFields from "../../../../src/components/docs/examples/Forms/RequiredFields";
import FormValidation from "../../../../src/components/docs/examples/Forms/FormValidation";
import FloatingLabels from "../../../../src/components/docs/examples/Forms/FloatingLabels";
import * as React from 'react';
export default {
  FormEntry,
  FormEntrySelect,
  FormEntryTextarea,
  FormEntryFileUpload,
  Checkboxes,
  CheckboxSingle,
  CheckboxSwitch,
  Radios,
  RequiredFields,
  FormValidation,
  FloatingLabels,
  React
};